/* ---------- shop flower by weight ---------- */
var WEIGHTS=[{g:4,label:'4 Grams',price:26.99},{g:14,label:'14 Grams',price:44.99},{g:28,label:'28 Grams',price:69.99}];
var SBW=[
 {name:'Maui Wowie',       type:'Sativa', cls:'b-sativa', base:69.99, card:EA('strain-maui-wowie.jpg'),        hand:null,                  vid:null},
 {name:'Granddaddy Purple',type:'Hybrid', cls:'b-hybrid', base:69.99, card:EA('strain-granddaddy-purple.jpg'), hand:EA('rev-r2.jpg'),   vid:EV('vid-gdp'),        poster:EA('vid-gdp-poster.jpg')},
 {name:'LA Confidential',  type:'Indica', cls:'b-indica', base:69.99, card:EA('strain-la-confidential.jpg'),   hand:EA('pdp-lac-2.jpg'),vid:EV('vid-lac'),        poster:EA('vid-lac-poster.jpg'), href:'product-la-confidential.html'},
 {name:'Sour Diesel',      type:'Sativa', cls:'b-sativa', base:69.99, card:EA('strain-sour-diesel.jpg'),       hand:EA('rev-r5.jpg'),   vid:EV('vid-sourdiesel'), poster:EA('vid-sourdiesel-poster.jpg')},
 {name:'Blue Dream',       type:'Sativa', cls:'b-sativa', base:69.99, card:EA('strain-blue-dream.jpg'),        hand:null,                  vid:null}
];
(function(){
  var wi=2, rail=document.getElementById('sbwRail'), tabs=document.getElementById('wtabs');
  if(!rail) return;
  function money(n){ return '$'+n.toFixed(2); }

  function drawTabs(){
    tabs.innerHTML=WEIGHTS.map(function(w,n){
      return '<button class="wtab'+(n===wi?' on':'')+'" data-n="'+n+'">'+w.label+'</button>';
    }).join('');
    [].forEach.call(tabs.children,function(b){
      b.addEventListener('click',function(){ wi=+b.dataset.n; drawTabs(); drawRail(); syncNav(); });
    });
  }
  function syncNav(){
    document.getElementById('wPrev').disabled = wi===0;
    document.getElementById('wNext').disabled = wi===WEIGHTS.length-1;
  }
  function drawRail(){
    var w=WEIGHTS[wi];
    rail.innerHTML=SBW.map(function(p,idx){
      var price=w.price;
      var media=[{k:'img',src:p.card}];
      if(p.hand) media.push({k:'img',src:p.hand});
      if(p.vid)  media.push({k:'vid',src:p.vid,poster:p.poster});
      var startIdx = media.length-1;                       // the video, when there is one
      var layers=media.map(function(m,n){
        return m.k==='img'
          ? '<img class="m'+(n===startIdx?' on':'')+'" src="'+m.src+'" alt="'+p.name+'" loading="lazy" decoding="async">'
          : '<video class="m'+(n===startIdx?' on':'')+'" src="'+m.src+'" poster="'+m.poster+'" muted loop playsinline preload="metadata"></video>';
      }).join('');
      var dots = media.length>1 ? '<div class="pdots">'+media.map(function(_,n){
            return '<button data-card="'+idx+'" data-i="'+n+'" class="'+(n===startIdx?'on':'')+'" aria-label="Media '+(n+1)+'"></button>';
          }).join('')+'</div>' : '';
      var badge = p.vid ? '<span class="pvid-badge">&#9658; Video</span>' : '';
      var open = p.href ? '<a href="'+p.href+'" style="color:inherit">' : '<div>';
      var close = p.href ? '</a>' : '</div>';
      return '<div class="pcard" data-card="'+idx+'">'+
        '<div class="pmedia">'+layers+badge+dots+'</div>'+
        '<div class="pbody">'+open+'<span class="pbrand">Elevana</span>'+
        '<span class="pname">'+p.name+'</span>'+
        '<span class="pmeta"><span class="badge '+p.cls+'" style="position:static;display:inline-block">'+p.type+'</span> &middot; '+w.label+'</span>'+close+
        '<div class="pfoot"><span class="pprice">'+money(price)+'<small>'+money(price/w.g)+' /g</small></span>'+
        '<button class="padd">Add</button></div></div></div>';
    }).join('');

    [].forEach.call(rail.querySelectorAll('.pdots button'),function(b){
      b.addEventListener('click',function(e){
        e.preventDefault(); e.stopPropagation();
        showMedia(rail.querySelector('.pcard[data-card="'+b.dataset.card+'"]'), +b.dataset.i);
      });
    });
    [].forEach.call(rail.querySelectorAll('.pcard'),function(c){
      c.addEventListener('mouseleave',function(){
        var n=c.querySelectorAll('.pmedia .m').length;
        showMedia(c, n-1);                                  // back to the video
      });
    });
    watchVideos();
    [].forEach.call(rail.querySelectorAll('.padd'),function(btn){
      btn.addEventListener('click',function(e){
        e.preventDefault(); e.stopPropagation();
        if(btn.dataset.busy) return; btn.dataset.busy='1';
        var t=btn.textContent; btn.classList.add('done'); btn.textContent='✓ Added';
        var n=document.querySelector('.cart-n'); if(n) n.textContent=(parseInt(n.textContent,10)||0)+1;
        setTimeout(function(){ btn.classList.remove('done'); btn.textContent=t; delete btn.dataset.busy; },1400);
      });
    });
  }
  function showMedia(card,i){
    if(!card) return;
    var ms=card.querySelectorAll('.pmedia .m');
    ms.forEach(function(m,n){
      m.classList.toggle('on', n===i);
      if(m.tagName==='VIDEO'){
        if(n===i){ if(m.preload==='none'||m.readyState===0){ m.preload='auto'; m.load(); }
                   var pr=m.play(); if(pr&&pr.catch) pr.catch(function(){}); }
        else { m.pause(); }
      }
    });
    var ds=card.querySelectorAll('.pdots button');
    ds.forEach(function(d,n){ d.classList.toggle('on', n===i); });
  }
  function watchVideos(){
    var vids=rail.querySelectorAll('video');
    if(!('IntersectionObserver' in window)){
      [].forEach.call(vids,function(v){ var pr=v.play(); if(pr&&pr.catch) pr.catch(function(){}); });
      return;
    }
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){
        var v=e.target;
        if(e.isIntersecting && v.classList.contains('on')){ var pr=v.play(); if(pr&&pr.catch) pr.catch(function(){}); }
        else { v.pause(); }
      });
    },{threshold:.35});
    [].forEach.call(vids,function(v){ io.observe(v); });
    // a scroll fallback, because IntersectionObserver does not fire in every embedded viewer
    var kick=function(){
      [].forEach.call(vids,function(v){
        var r=v.getBoundingClientRect();
        var seen=r.top<innerHeight*.9 && r.bottom>innerHeight*.1;
        if(seen && v.classList.contains('on') && v.paused){ var pr=v.play(); if(pr&&pr.catch) pr.catch(function(){}); }
      });
    };
    window.addEventListener('scroll',kick,{passive:true});
    setTimeout(kick,400);
  }

  document.getElementById('wPrev').addEventListener('click',function(){ if(wi>0){wi--;drawTabs();drawRail();syncNav();} });
  document.getElementById('wNext').addEventListener('click',function(){ if(wi<WEIGHTS.length-1){wi++;drawTabs();drawRail();syncNav();} });
  drawTabs(); drawRail(); syncNav(); watchVideos();
})();
